import React from "react";

import "./styles.less";

export const MobileTable = ({ children }) => <div className="tables-list">{children}</div>;
